import { takeLatest, put, call } from 'redux-saga/effects';
import { httpService } from '@commons';

import {
  LIBERAR_CONTA_AGRARE,
  LIBERAR_CONTA_AGRARE_PENDING,
  LIBERAR_CONTA_AGRARE_SUCCESS,
  LIBERAR_CONTA_AGRARE_FAILURE,
  NEW_FILTER_CONTA_AGRARE
} from '../actionTypes';

const liberarConta = async (id, data) => {
  return httpService.putApiManager(`/clienteAgrare/liberar/${id}`, data);
}

function* sagaLiberarContaAgrare(action) {
  yield put({ type: LIBERAR_CONTA_AGRARE_PENDING });

  try {
    const registro = yield call(liberarConta, action.id, action.data);
    yield put({ type: LIBERAR_CONTA_AGRARE_SUCCESS, registro });

    yield put({ type: NEW_FILTER_CONTA_AGRARE, newFilter: false });

    if (action.resolve) {
      action.resolve();
    }
  } catch (error) {
    yield put({ type: LIBERAR_CONTA_AGRARE_FAILURE, error });

    if (action.reject) {
      action.reject(error);
    }
  }
}

export default function* watchLiberarContaAgrare() {
  yield takeLatest(LIBERAR_CONTA_AGRARE, sagaLiberarContaAgrare);
}
